import loaderIcon from "../../assets/gifs/Animation - 1702974649097.gif";

const Loader = () => (
  <div className="">
    <img src={loaderIcon} alt="loader" width={96} height={96} className="animate-spin" />
  </div>
);

export default Loader;
